import { apiGet, apiPost, apiRequest } from "./client";

export const EVENT_TYPES = ["meeting", "collab", "post", "live", "custom"];

const qs = ({ start, end }) => {
  const p = new URLSearchParams();
  if (start) p.set("start", start);
  if (end) p.set("end", end);
  const s = p.toString();
  return s ? `?${s}` : "";
};

export const planningAdminApi = {
  list: (modelId, range) =>
    apiGet(`/api/admin/planning/models/${modelId}/events${qs(range || {})}`),
  create: (modelId, data) =>
    apiPost(`/api/admin/planning/models/${modelId}/events`, data),
  update: (eventId, patch) =>
    apiRequest(`/api/admin/planning/events/${eventId}`, {
      method: "PATCH",
      body: patch,
    }),
  remove: (eventId) =>
    apiRequest(`/api/admin/planning/events/${eventId}`, { method: "DELETE" }),
};

export const planningPortalApi = {
  list: (range) => apiGet(`/api/planning/events${qs(range || {})}`),
  create: (data) => apiPost(`/api/planning/events`, data),
  update: (eventId, patch) =>
    apiRequest(`/api/planning/events/${eventId}`, {
      method: "PATCH",
      body: patch,
    }),
  remove: (eventId) =>
    apiRequest(`/api/planning/events/${eventId}`, { method: "DELETE" }),
};
